import { SVGProps } from 'react'

export function TrafficLightsIcon(properties: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
	return (
		<svg aria-hidden="true" viewBox="0 0 42 10" fill="none" {...properties}>
			<circle cx="5" cy="5" r="4.5" />
			<circle cx="21" cy="5" r="4.5" />
			<circle cx="37" cy="5" r="4.5" />
		</svg>
	)
}
